import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ResourcesService {

  constructor(private http: HttpClient) {

  }

  /**
   *
   * @returns
   */
  getListRoutes() {
    return this.http.get(`${environment.api_cm_resources}/listRoutes`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListManageEngine() {
    return this.http.get(`${environment.api_cm_resources}/listManageEngine`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListAdo() {
    return this.http.get(`${environment.api_cm_resources}/listAdo`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListTeam() {
    return this.http.get(`${environment.api_cm_resources}/listTeam`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListVendor() {
    return this.http.get(`${environment.api_cm_resources}/listVendor`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListContract() {
    return this.http.get(`${environment.api_cm_resources}/listContract`)
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  saveResources(param: any) {
    return this.http.post(`${environment.api_cm_resources}/saveResources`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListResources(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_resources}/listResources`, { params: params })
      .pipe(map(data => data));
  }

}
